import basicIcon from 'img/basic-icon.svg';
import recapIcon from 'img/recap-icon.svg';
import testIcon from 'img/test-icon.svg';

export const BLOCK_STATUS = {
  ADDED: 'ADDED',
  IN_PROGRESS: 'IN PROGRESS..',
  COMPLETED: 'COMPLETED',
  MASTERED: 'MASTERED',
};

export const OPTIONAL_STATUS = {
  COMPLETED: 'COMPLETED',
  NOT_COMPLETED: 'NOT_COMPLETED',
};

export const HEADER_ICONS = {
  DEFAULT: basicIcon,
  PREREQ: basicIcon,
  RECAP: recapIcon,
  TESTS: testIcon,
};
